import React from 'react';
import { connect } from 'react-redux';
import * as actions from '../registrationActions';
import RegistrationForm from './RegistrationForm';

const RegistrationContainer = ({
  registrationReducer,
  authReducer,
  createAccount,
  setSignupFailError,
  minPasswordLength,
  registrationError,
  clearRegistrationErrorMessage,
  isPasswordLess,
  setActiveStep,
  enteredPhoneNumber,
  setEnteredPhoneNumber,
  appConfig,
}) => {
  const { requestingCreateAccount, signUpFailureError } = registrationReducer;
  const { is_captcha_enabled: isCaptchaEnabled } = authReducer?.appConfig || {};

  const isBirthdayEnabled = authReducer.appConfig.get_birthday;

  const showReferralCode = authReducer.appConfig.show_referral_code;

  return (
    <RegistrationForm
      setSignupFailError={setSignupFailError}
      createAccount={createAccount}
      isRequesting={requestingCreateAccount}
      isBirthdayEnabled={isBirthdayEnabled}
      showReferralCode={showReferralCode}
      signUpFailureError={signUpFailureError}
      minPasswordLength={minPasswordLength}
      registrationError={registrationError}
      clearRegistrationErrorMessage={clearRegistrationErrorMessage}
      isPasswordLess={isPasswordLess}
      setActiveStep={setActiveStep}
      enteredPhoneNumber={enteredPhoneNumber}
      setEnteredPhoneNumber={setEnteredPhoneNumber}
      appConfig={appConfig}
      isCaptchaEnabled={isCaptchaEnabled}
    />
  );
};

const mapStateToProps = (state) => ({
  registrationReducer: state.registrationReducer,
  authReducer: state.authReducer,
  minPasswordLength:
    state.authReducer.appConfig?.password_complexity_min_length,
  registrationError: state.registrationReducer.registrationError,
  isPasswordLess: state.authReducer.appConfig?.is_password_less,
});

export default connect(mapStateToProps, actions)(RegistrationContainer);
